import { useEffect } from 'react'

export default function useConfigurePosthog () {
  useEffect(() => {
    window.posthog?.set_config({ capture_pageview: 'history_change' })
  }, [])
}
